class Match {
  constructor(player1, player2, result) {
    this.player1 = player1;
    this.player2 = player2;
    this.result = result;

    this.player1.addMatch(this);
    this.player2.addMatch(this);

    console.log(this.player1.name, result === Match.RESULT_WIN ? 'won' : (result === Match.RESULT_LOSS ? 'lost' : 'draw'), 'against', this.player2.name, '#', this.player1.score, ':', this.player2.score);
    console.log(this.player1.name, '=', this.player1.score, this.player2.name, '=', this.player2.score);
  }
}

// possible results
Match.RESULT_WIN = 1;
Match.RESULT_DRAW = 0;
Match.RESULT_LOSS = -1;


class Player {
  constructor(name, data) {
    this.name = name; // just to have any identification
    this.score = 0;
    this.wins = 0;
    this.losses = 0;
    this.draws = 0;
    this.data = data;
    this.matches = [];
  }

  addMatch(match) {
    console.log(this.name);
    console.log(match.result);
    console.log('add_match', match);
    this.matches.push(match);

    // check if the first player is this one
    if (match.player1.name === this.name) {
      // this player1 has WON against player2
      if (match.result === Match.RESULT_WIN) {
        this.wins++;
        this.score++;
      } else {
        this.wins--;
        this.score--;
      }
      // this player is player2
    } else {
      // player1 has LOST against this player2
      if (match.result === Match.RESULT_LOSS) {
        this.wins++;
        this.score++;
      } else {
        this.wins--;
        this.score--;
      }
    }
  }

  hasPlayedAgainst(player) {
    // a player canot play against him/herself
    if (this.name === player.name) return false;

    // check the other matches
    for (let i = 0; i < this.matches.length; i++) {
      const match = this.matches[i];

      if (match.player1.name === player.name || match.player2.name === player.name) return true;
    }
    return false;
  }
}

class Scene {
  constructor(players) {
    this.playerList = [];

    for (const p of players) {
      this.playerList.push(new Player(p.id, p));
    }

    this.matchesGenerator = this.matchGenerator();
    this.round = 0;
  }

  addMatch(p1, p2, result) {
    if (result === 'win') {
      const m1 = new Match(p1, p2, Match.RESULT_WIN);
      console.log(m1)
    } else {
      const m2 = new Match(p1, p2, Match.RESULT_LOSS);
      console.log(m2)
    }
  }

  nextMatch() {
    const i = this.matchesGenerator.next();
    if (i.done) {
      return null;
    }
    return { p1: i.value[0], p2: i.value[1] };
  }

  getResults() {
    this.playerList.sort((player1, player2) => player2.score - player1.score);

    // print the results
    console.log('-----');

    for (let i = 0; i < this.playerList.length; i++) {
      const player = this.playerList[i];
      console.log('Rank', i + 1, ':', player.name, 'with', player.score, 'points');
    }

    return this.playerList;
  }


  * matchGenerator() {
    const MAX_SCORE_DIFFERENCE = 2;
    let matchPossible = true;

    while (matchPossible) {
      matchPossible = false;
      for (const player1 of this.playerList) {
        // exclude players who already played this round
        if (player1.matches.length > this.round) {
          continue;
        }

        for (const player2 of this.playerList) {
          // do not play against him/herself
          if (player1.name === player2.name) {
            continue;
          }

          // exclude players who already played this round
          if (player2.matches.length > this.round) {
            continue;
          }

          // the two already faced each other
          if (player1.hasPlayedAgainst(player2)) {
            continue;
          }

          // their scores are too far apart
          if (Math.abs(player1.score - player2.score) > MAX_SCORE_DIFFERENCE) {
            continue;
          }

          // there was a match!
          matchPossible = true;

          // if we get here, the players should face each other
          yield [player1, player2];
          // new Match(player1, player2, Match.randomResult());

          // break out, let the next players have a match
          break;
        }
      }
      // start the next round
      this.round++;
    }
  }
}

module.exports = {
  Scene,
  Match,
};
